import cx from 'classnames';
import styles from './LotteryGameRoomBodyButton.module.scss';

import { Dispatch, FC, memo, SetStateAction, useEffect } from 'react';
import { Typography } from '@shared/Typography';
import { GameStage } from '@entities/game';
import { vibrateImpact } from '@utils/vibrate';
import { SuperTicketType } from '@features/LotteryGame/types';
import { getTicketClassName } from '@features/LotteryGame/helpers/ticketNumberUtils';

interface LotteryGameRoomBodyButtonProps {
  num: number;
  stage: GameStage;
  myNumber: boolean;
  winNumber?: boolean;
  onClick: (num: number) => void;
  anotherNumber: boolean;
  setCountWinNums?: Dispatch<SetStateAction<number>>;
  luckyTicketNumber?: string;
}

export const LotteryGameRoomBodyButton: FC<LotteryGameRoomBodyButtonProps> = memo(
  ({
    num,
    stage,
    onClick,
    myNumber,
    winNumber,
    anotherNumber,
    setCountWinNums,
    luckyTicketNumber,
  }) => {
    useEffect(() => {
      if (myNumber && winNumber && setCountWinNums) {
        setCountWinNums((prev) => (prev > 4 ? 1 : prev + 1));
        vibrateImpact('soft');
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myNumber, winNumber]);

    const getBtnClassName = (
      myNumber: boolean,
      anotherNumber: boolean,
      winNumber?: boolean,
    ) => {
      if (winNumber) {
        if (myNumber) return styles.btnIamWinner;
        else return styles.btnWinner;
      } else if (myNumber) return styles.myBtnColor;
      else if (anotherNumber) return styles.btnPicked;
      else if (stage === 'myTurn') return styles.btnAvailable;
      else return styles.btnDisabled;
    };

    const ticketClass = getTicketClassName(luckyTicketNumber as SuperTicketType);

    return (
      <button
        key={num}
        onClick={() => onClick(num)}
        className={cx(
          styles.gameButton,
          getBtnClassName(myNumber, anotherNumber, winNumber),
          styles[ticketClass!],
        )}
      >
        <Typography
          component="h2"
          data-text={num}
          className={cx(
            styles.btnAvailableText,
            styles.gameBtnTextWinner,
            styles.gameBtnTextIamWinner,
            styles.gameBtnTextAnotherNumberFinished,
          )}
        >
          {num}
        </Typography>
      </button>
    );
  },
);
